import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AdminLogin from './AdminLogin';
import RequireAuth from './RequireAuth';
import Dashboard from './page/Dashboard';
import UserList from './page/UserList';
import CertificationCandidates from './page/CertificationCandidates';
import KpiDashboard from './page/KpiDashboard';
import StoreList from './page/StoreList';
import StoreDetail from './page/StoreDetail';
import StoreReview from './page/StoreReview';
import StoreAddRequests from './page/StoreAddRequests';
import ImageQueue from './page/ImageQueue';
import VideoLinkQueue from './page/VideoLinkQueue';
import ChainEditor from './page/ChainEditor';
import PostModeration from './page/PostModeration';
import ScanList from './page/ScanList';
import StoreImport from './page/StoreImport';
import B2BAccounts from './page/B2BAccounts';
import PrizeAnalytics from './page/PrizeAnalytics';
import StoreAnalytics from './page/StoreAnalytics';
import PartnerDashboard from './page/PartnerDashboard';
import PartnerScans from './page/PartnerScans';
import PartnerStoreChecklist from './page/PartnerStoreChecklist';
import PartnerEarnings from './page/PartnerEarnings';
import PartnerManagement from './page/PartnerManagement';
import VideoUpload from './page/VideoUpload';
import StoreMedia from './page/StoreMedia';
import PocDatasets from './page/PocDatasets';
import TypeCountSettings from './page/TypeCountSettings';
import PocAnnotate from './page/PocAnnotate';
import PocReport from './page/PocReport';
import PocCoverage from './page/PocCoverage';
import PocTracks from './page/PocTracks';
import Videos from './page/Videos';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Partner routes (accessible by both admin and partner) */}
          <Route element={<RequireAuth />}>
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/partner/scans" element={<PartnerScans />} />
            <Route path="/partner/stores" element={<PartnerStoreChecklist />} />
            <Route path="/partner/earnings" element={<PartnerEarnings />} />
          </Route>

          {/* Admin-only routes */}
          <Route element={<RequireAuth adminOnly />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<UserList />} />
            <Route path="/contributors/candidates" element={<CertificationCandidates />} />
            <Route path="/analytics/kpi" element={<KpiDashboard />} />
            <Route path="/stores" element={<StoreList />} />
            <Route path="/stores/review" element={<StoreReview />} />
            <Route path="/stores/add-requests" element={<StoreAddRequests />} />
            <Route path="/images/queue" element={<ImageQueue />} />
            <Route path="/videos/link-queue" element={<VideoLinkQueue />} />
            <Route path="/chains" element={<ChainEditor />} />
            <Route path="/stores/:id" element={<StoreDetail />} />
            <Route path="/scans" element={<ScanList />} />
            <Route path="/videos" element={<Videos />} />
            {/* 旧URL。共有されたリンクとブックマークを生かす */}
            <Route path="/videos/linking" element={<Navigate to="/videos?tab=linking" replace />} />
            <Route path="/posts/moderation" element={<PostModeration />} />
            <Route path="/import/stores" element={<StoreImport />} />
            <Route path="/b2b/accounts" element={<B2BAccounts />} />
            <Route path="/analytics/prizes" element={<PrizeAnalytics />} />
            <Route path="/analytics/stores" element={<StoreAnalytics />} />
            <Route path="/partners" element={<PartnerManagement />} />
            <Route path="/video-upload" element={<VideoUpload />} />
            <Route path="/youtube-curation" element={<Navigate to="/videos" replace />} />
            <Route
              path="/videos/suggestions"
              element={<Navigate to="/videos?tab=suggestions" replace />}
            />

            {/* Video Scan PoC bench: PH0 → PH1 → PH1.5 */}
            <Route path="/store-media" element={<StoreMedia />} />
            <Route path="/settings" element={<TypeCountSettings />} />
            <Route path="/poc" element={<PocDatasets />} />
            <Route path="/poc/:datasetId/annotate" element={<PocAnnotate />} />
            <Route path="/poc/:datasetId/report" element={<PocReport />} />
            <Route path="/poc/:datasetId/coverage" element={<PocCoverage />} />
            <Route path="/poc/:datasetId/tracks" element={<PocTracks />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
